<template>
    <div class="menu-wrap" :style="{ zIndex: (foldMiniOpenStatus || foldHeaderBarOpenStatus) ? '4' : 'auto' }">
        <div class="left-menu-wrap">
            <!--顶部导航-->
            <div class="header-menu-wrap" v-show="foldHeaderBarOpenStatus">
                <div class="left-menu-mask" v-show="typing"/>
                <div class="shrink-image shrink-image--open" @click="changeFoldOpenStatus"></div>
            </div>
            <div v-show="typing || foldMiniOpenStatus" class="left-menu-mask"
                 :class="foldMiniOpenStatus ? 'left-menu-mask--mini' : ''" @click="handleMenuMask"/>
            <div v-show="!foldOpenStatus && !foldHeaderBarOpenStatus" class="left-menu-hidden-bar">
                <div class="hidden-bar__header">
                    <div class="header-logo-wrap">
                        <div class="header-logo"></div>
                    </div>
                    <div class="header-add-wrap flex-center-hori" @click="$emit('newChat')">
                        <img class="header-add" src="@/theme/images/icons/icon_add_outline.svg"/>
                    </div>
                </div>
                <div class="hidden-bar__footer">
                    <div class="shrink-image shrink-image--open" @click="changeFoldOpenStatus"></div>
                </div>
            </div>
            <div v-show="foldOpenStatus || foldMiniOpenStatus" class="left-menu"
                 :class="foldMiniOpenStatus ? 'left-menu--mini' : ''">
                <div class="left-menu-hero flex-center-hori">
                    <img class="hero-image" src="@/theme/images/hero_logo.png"/>
                </div>
                <div v-if="historyMap" class="left-menu-tab">
                    <el-tabs v-model="activeName" v-show="!isSearching">
                        <template v-for="item in allTypes">
                            <el-tab-pane :key="item.name" :name="item.name">
                                <template #label>
                                  <span class="tab-item">
                                    <img :src="require('@/theme/images/' + item.name + '.png')" class="history-icon" />
                                    <span>{{item.label}}</span>
                                  </span>
                                </template>
                            </el-tab-pane>
                        </template>
                    </el-tabs>
                    <div class="tab-search-overlay" :class="{ active: isSearching }">
                        <img class="search-active-icon" src="@/theme/images/icons/icon_search_active_outline.svg"
                             v-show="isSearching">
                        <textarea rows="1" v-model="searchQuery" placeholder="搜索..." v-show="isSearching"></textarea>
                        <img src="@/theme/images/icons/icon_search_outline.svg" v-show="!isSearching"
                             @click="isSearching = true">
                        <img class="search-active-icon" src="@/theme/images/icons/icon_cancel_outline_white.svg"
                             v-show="isSearching" @click="searchQuery = ''">
                        <div v-show="isSearching" @click="isSearching = false">取消</div>
                    </div>
                </div>
                <div v-show="model !== 'knowledge' && !isSearching" class="new-chat-button flex-center-hori"
                     @click="$emit('newChat')">
                    <img src="@/theme/images/add.png" alt="">
                    <span class="new-chat_text">新建对话</span>
                </div>
                <div class="left-menu-content" v-if="isSearching">
                    <div class="sort-title">搜索结果</div>
                    <ChatHistoryCard v-for="(chat, index) in searchedHistory" :key="index + Math.random()" :chat="chat"
                                     :query="searchQuery" :isSearching="isSearching"/>
                </div>
                <div class="left-menu-content" v-else-if="!isSearching">
                    <div class="rightplace">
                        <el-checkbox v-model="starOnly">只看星级</el-checkbox>
                    </div>
                    <template v-if="!starOnly">
                        <template v-for="(historyItem, historyItemIndex) in curShowHistoryMap[model]">
                            <div class="sort-item" :key="historyItem.title" v-if="historyItem.list.length && historyItemIndex !== 0">
                                <div class="sort-title">{{historyItem.title}}</div>
                                <ChatHistoryCard v-for="(chat, index) in historyItem.list" :key="index + Math.random()"
                                                 :chat="chat"/>
                            </div>
                        </template>
                    </template>
                    <div class="sort-item" v-if="starOnly && curShowHistoryMap[model].length && curShowHistoryMap[model][0]['list'].length">
                        <div class="sort-title">星级对话</div>
                        <ChatHistoryCard v-for="(chat, index) in curShowHistoryMap[model][0]['list']" :key="index + Math.random()"
                                         :chat="chat"/>
                    </div>
                </div>
                <div class="left-menu-content" v-else></div>

                <div class="left-menu-footer flex-center-hori">
                    <el-dropdown trigger="click" @visible-change="changeUserTextStyle">
                        <div class="user-info flex-center-hori">
                            <img>
                            <div class="footer-text">{{ username }}</div>
                        </div>
                        <el-dropdown-menu slot="dropdown" :append-to-body="false">
                            <el-dropdown-item @click.native.stop="showConfig = true">
                                <span>个人设置</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native.stop="showChangePass = true">
                                <span>修改密码</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="logout">
                                <span>退出登录</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="left-menu-shrink shrink-image shrink-image--close" @click="changeFoldOpenStatus"></div>
                </div>
            </div>
        </div>
        <ConfigBox :visible.sync="showConfig"/>
        <ChangePasswordBox :visible.sync="showChangePass"/>
        <ExportSessionBox :visible.sync="showExportSession" :sessionId="exportSessionId"/>
    </div>
</template>
<script>
import ConfigBox from './ConfigBox.vue';
import ChangePasswordBox from './ChangePasswordBox.vue';
import ExportSessionBox from './ExportSessionBox.vue';
import ChatHistoryCard from './ChatHistoryCard.vue';
import SwitchBar from './SwitchBar.vue';
import { PC_H5_CFG } from '@/app/constant/PC_H5_CFG'; // 响应式布局配置
import accountApi from '@/api/account.api';

const dayMS = 1000 * 60 * 60 * 24;
const timeStampNow = Date.now();
const day1Start = timeStampNow - (timeStampNow % dayMS);
const day7Start = day1Start - (dayMS * 6);
const day30Start = day1Start - (dayMS * 29);

export default {
    name: 'LeftMenu',
    components: { ConfigBox, ChangePasswordBox, ExportSessionBox, ChatHistoryCard, SwitchBar },
    provide () {
        return {
            exportSession: this.exportSession
        };
    },
    props: {
        // knowledge: 知识库对话 | commonMode：常规对话
        model: {
            type: String,
            default: 'commonMode'
        },
        tabs: {
            type: Array,
            default: () => []
        },
        typing: {
            type: Boolean,
            default: false
        },
        historyMap: {
            type: Object,
            default: () => {}
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            activeName: 'commonMode',
            allTypes: [
                { name: 'commonMode', label: '常规对话' },
                { name: 'knowledge', label: '知识库对话' }
            ],
            onlineUserCount: 0, // 在线人数
            showChangePass: false,
            showConfig: false,
            showExportSession: false, // 是否显示导出会话
            exportSessionId: null, // 导出会话id
            originalPass: '',
            newPass: '',
            newPassVerify: '',
            foldOpenStatus: true, // 左侧菜单是否展开
            foldMiniOpenStatus: false, // 左侧菜单是否展开（小条）
            foldHeaderBarOpenStatus: false, // 左侧菜单是否展开（头部）
            isSearching: false,
            searchQuery: '',
            innerWidth: 0,
            starOnly: false, // 是否只显示收藏的聊天
            curShowHistoryMap: {}
        };
    },
    watch: {
        activeName (val) {
            if (val === 'commonMode') {
                let curChatSessionId = '';
                if (this.curShowHistoryMap[val]) {
                    for (let i = 1; i < this.curShowHistoryMap[val].length; i++) {
                        if (this.curShowHistoryMap[val][i]['firstSessionId']) {
                            curChatSessionId = this.curShowHistoryMap[val][i]['firstSessionId'];
                            break;
                        }
                    }
                }
                this.$emit('selectNormal', curChatSessionId);
            } else {
                this.$emit('selectKnowledge');
            }
        },
        model (val) {
            this.activeName = val;
            if (!this.curShowHistoryMap[this.model]) {
                this.sortedHistory();
            }
        },
        show (val) {
            // 最小pc端宽度以下都走浮层菜单
            if (this.innerWidth <= PC_H5_CFG.MIN_PC_INNER_WIDTH) {
                this.foldMiniOpenStatus = val;
            } else {
                this.foldOpenStatus = val;
            }
        },
        historyMap: {
            handler (val) {
                if (JSON.stringify(val) === '{}') {
                    return;
                }
                this.sortedHistory();
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        },
        isDebug () {
            return this.$store.state.appSettings.isDebug;
        },
        username () {
            return this.$store.state.account.username;
        },
        searchedHistory () {
            let result = [];
            if (!this.searchQuery.length) return result;
            for (const sessionId in this.historyMap) {
                const session = this.historyMap[sessionId];
                if (session.title.indexOf(this.searchQuery) !== -1) result.push(session);
            }
            return result;
        }
    },
    mounted () {
        this.refreshOnlineUserCount();

        // 初始化是否隐藏左侧菜单
        this.windowSizeHandle({
            target: {
                navigator: true,
                innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            }
        });
        // this.listenWindowSize();  //取消响应式
    },
    methods: {
        sortedHistory () {
            let sorted = {
                star: [],
                day1: [],
                day7: [],
                day30: [],
                older: []
            };
            for (const sessionId in this.historyMap) {
                const session = this.historyMap[sessionId];
                if (this.model === 'commonMode') {
                    if (session.knowledgeId) continue; // 跳过知识库会话
                    else if (session.promptTemplateCode) continue; // 跳过助手会话
                } else {
                    if (!session.knowledgeId) continue; // 跳过非知识库会话
                }

                if (session.collected === 1) sorted.star.push(session);
                if (session.createdTimeStamp > day1Start) sorted.day1.push(session);
                else if (session.createdTimeStamp > day7Start) sorted.day7.push(session);
                else if (session.createdTimeStamp > day30Start) sorted.day30.push(session);
                else sorted.older.push(session);
            }
            this.curShowHistoryMap[this.model] = [
                {
                    title: '星级对话',
                    list: sorted.star.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp),
                    firstSessionId: sorted.star.length ? sorted.star[0]['sessionId'] : ''
                },
                {
                    title: '今天',
                    list: sorted.day1.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp),
                    firstSessionId: sorted.day1.length ? sorted.day1[0]['sessionId'] : ''
                },
                {
                    title: '7天内',
                    list: sorted.day7.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp),
                    firstSessionId: sorted.day7.length ? sorted.day7[0]['sessionId'] : ''
                },
                {
                    title: '30天内',
                    list: sorted.day30.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp),
                    firstSessionId: sorted.day30.length ? sorted.day30[0]['sessionId'] : ''
                },
                {
                    title: '更久远的聊天',
                    list: sorted.older.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp),
                    firstSessionId: sorted.older.length ? sorted.older[0]['sessionId'] : ''
                }
            ];
        },
        /**
         * 刷新在线用户数
         */
        async refreshOnlineUserCount () {
            let ret = await accountApi.getOnlineUser();
            this.onlineUserCount = ret.data;
            setTimeout(this.refreshOnlineUserCount, 60 * 60 * 1000);
        },
        listenWindowSize () {
            window.addEventListener('resize', this.windowSizeHandle, true);
        },
        // 折叠状态改变
        changeFoldOpenStatus () {
            // 最小pc端宽度以下都走浮层菜单
            if (this.innerWidth <= PC_H5_CFG.MIN_PC_INNER_WIDTH) {
                this.foldMiniOpenStatus = !this.foldMiniOpenStatus;
            } else {
                this.foldOpenStatus = !this.foldOpenStatus;
            }
        },
        // 最小pc端宽度的时候就折叠左侧菜单栏
        windowSizeHandle (e) {
            // 必须是window对象的改变才能触发，因为video对象也会触发resize
            if (!e.target.navigator) {
                return;
            }
            this.innerWidth = e.target.innerWidth;
            if (this.innerWidth <= PC_H5_CFG.MIN_PC_INNER_WIDTH) {
                // 最大h5端宽度的时候显示顶部菜单栏
                this.foldHeaderBarOpenStatus = this.innerWidth <= PC_H5_CFG.MAX_PHONE_INNER_WIDTH;
                if (this.foldOpenStatus) {
                    this.foldOpenStatus = false;
                }
            } else if (this.innerWidth > PC_H5_CFG.MIN_PC_INNER_WIDTH && !this.foldOpenStatus) {
                this.foldOpenStatus = true;
                this.foldMiniOpenStatus = false;
                this.foldHeaderBarOpenStatus = false;
            }
        },
        // 处理蒙层点击
        handleMenuMask () {
            if (this.foldMiniOpenStatus) {
                this.foldMiniOpenStatus = false;
                this.foldOpenStatus = false;
            }
        },
        toggleDark () {
            this.$store.commit('appSettings/toggleDark');
        },
        toggleDebug () {
            this.$store.commit('appSettings/toggleDebug');
        },
        toggleLLM () {
            this.$store.commit('appSettings/toggleLLM');
        },
        logout () {
            this.$store.commit('account/logout');
        },
        // 修改左侧菜单底部用户名文字样式
        changeUserTextStyle (val) {
            let ele = document.getElementsByClassName('footer-text')[0];
            if (val) {
                ele.style.color = 'rgba(255, 255, 255, 1)';
            } else {
                ele.style.color = 'rgba(255, 255, 255, 0.65)';
            }
        },

        /**
         * 导出会话
         */
        exportSession (sessionId) {
            this.showExportSession = true;
            this.exportSessionId = sessionId;
        }
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.windowSizeHandle);
    }
};
</script>
<style lang="scss" scoped>
.menu-wrap {
    height: 100%;
    position: relative;
}

.shrink-image {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.shrink-image--open {
    background-image: var(--shrink-open-img);
    background-size: cover;
}

.shrink-image--close {
    background-image: var(--shrink-close-img);
    background-size: cover;
}

.header-menu-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 56px;
    background: var(--menu-header-bar-bg);
    display: flex;
    align-items: center;
    padding: 0 26px;
}

.left-menu-wrap {
    height: 100%;
    position: relative;
    flex-shrink: 0;

    .left-menu-mask {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        opacity: 0.5;
        z-index: 2;
    }

    .left-menu-mask--mini {
        position: fixed;
        background-color: rgba(1, 11, 30, 0.85);
        backdrop-filter: blur(4px);
        opacity: 0.85;
        transition: opacity 320ms, backdrop-filter 200ms;
        z-index: auto;
    }

    .left-menu__fold-wrap {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;

        .fold-img {
            width: 14px;
            height: 51px;
        }
    }
}

.left-menu-hidden-bar,
.left-menu {
    height: 100%;
    flex: 0 0 auto;
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    overflow: hidden;
}

.left-menu--mini {
    position: fixed;
    top: 0;
    left: 0;
}

.left-menu {
    width: 288px;
    background: var(--menu-bg);

    .left-menu-hero {
        width: 100%;
        height: 72px;
        flex: 0 0 auto;

        .hero-image {
            width: 224px;
        }
    }

    .new-chat-button {
        width: 260px;
        padding: 10px 0;
        box-sizing: border-box;
        border-radius: 4px;
        user-select: none;
        border: 1px solid rgba(255, 255, 255, 0.6);
        cursor: pointer;
        flex-shrink: 0;
        margin: 4px 0 16px 0;
        color: rgba(255, 255, 255, 0.7);
        .new-chat_text {
            flex: 0 0 auto;
            line-height: 24px;
            margin: 0 4px;
        }
    }
    .left-menu-tab {
        width: 256px;
        height: 39px;
        flex: 0 0 auto;
        margin: 16px 0;
        position: relative;
        z-index: 1;

        .list-title {
            color: #FFFFFF;
            width: 100%;
            height: 100%;
            line-height: 39px;
            border-bottom: 1px solid rgba(255,255,255,0.25);
            .history-icon {
                height: 16px;
                width: 16px;
                margin: 0 4px 2px 0;
                display: inline;
            }
        }

        .star-icon {
            height: 16px;
            width: 16px;
            margin: 0px 4px 2px 0px;
            display: inline;
        }

        .tab-item {
            img {
                width: 18px;
                margin-right: 4px;
                margin-top: -4px;
            }
        }

        .tab-search-overlay {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: flex-end;
            pointer-events: none;

            &.active {
                border-bottom: 1px solid rgba($color: white, $alpha: 0.15);
            }

            > textarea {
                resize: none;
                flex: 1 1 auto;
                background-color: transparent;
                padding: 12px 4px;
                box-sizing: border-box;
                border: 0 none;
                border-radius: 0;
                color: white;
                font-size: 14px;
                pointer-events: auto;

                &::placeholder {
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.45);
                }

                &:focus {
                    border: 0 none;
                    border-radius: 0;
                    outline: none;
                }
            }

            > img {
                flex: 0 0 auto;
                height: 18px;
                cursor: pointer;
                pointer-events: auto;
            }

            > div {
                flex: 0 0 auto;
                font-size: 14px;
                color: rgba($color: #ffffff, $alpha: 0.65);
                line-height: 20px;
                pointer-events: auto;
                user-select: none;
                cursor: pointer;
            }

            .search-active-icon {
                height: 16px;
                margin: 0 4px;
            }
        }

        ::v-deep {
            .el-tabs__item {
                color: rgba(255, 255, 255, 0.65);
                padding-left: 0px;
                line-height: 36px;
                font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
            }

            .el-tabs__header {
                margin-bottom: 0;
            }

            .el-tabs__active-bar {
                background-color: white;
            }

            .el-tabs__item.is-active {
                color: #ffffff;
            }

            .el-tabs__nav-wrap::after {
                background-color: rgba(255, 255, 255, 0.15);
                height: 1px;
            }
        }
    }

    .left-menu-content {
        // position: relative;
        width: 100%;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 24px;
        flex: 1 1 auto;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;

        &:hover::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.15);
        }

        &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(255, 255, 255, 0.25);
        }

        .sort-item {
            width: 100%;
        }
        .sort-title {
            margin: 0 0 8px 20px;
            font-size: 12px;
            color: rgba($color: #ffffff, $alpha: 0.65);
            line-height: 18px;
        }

        .rightplace {
            position: absolute;
            right: 16px;
            font-size: 0.75em;

            .el-checkbox {
                font-size: 1em;
                display: flex;
                align-items: center;
                height: 16px;

                &::v-deep {
                    .el-checkbox__input {
                        height: 10px;
                    }
                    .el-checkbox__inner {
                        width: 10px;
                        height: 10px;
                        border: 0px solid #FFF;
                        box-sizing: border-box;
                        background: url('~@/theme/images/icons/unchecked.svg');

                        &::after {
                            display: none;
                        }
                    }

                    .is-checked .el-checkbox__inner {
                        background: url('~@/theme/images/icons/checked.svg');
                    }

                    .el-checkbox__label {
                        font-size: 1em;
                        padding-left: 4px;
                        line-height: 1em;
                        color: rgba(255, 255, 255, 0.65);
                    }
                }
            }
        }
    }

    .knowledge-history {
        .chat-history {
            height: 56px;
        }
    }

    .left-menu-footer {
        width: 100%;
        height: 56px;
        box-sizing: border-box;
        flex: 0 0 auto;
        box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 16px;

        .message-onlineUserCount {
            position: absolute;
            top: -20px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
            pointer-events: none;
        }

        .user-info {
            user-select: none;
            cursor: pointer;

            > img {
                height: 24px;
                content: var(--user-profile-icon);
            }

            .footer-text {
                margin-left: 10px;
                font-size: 16px;
                color: rgba(255, 255, 255, 0.65);
                line-height: 22px;
            }
        }

        .left-menu-shrink {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
        }

        ::v-deep {
            .el-dropdown {
                position: unset;
            }

            .el-dropdown-menu {
                width: 180px;
                background-color: var(--el-popper-bg);
                margin-left: 8px;
                margin-bottom: 8px;
                padding: 0;
                border-radius: 4px;
                border: 0 solid var(--el-popper-bg);

                .el-dropdown-menu__item {
                    position: relative;
                    padding: 0 16px;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    color: rgba(255, 255, 255, 0.85);

                    > span {
                        width: 100%;
                        height: 48px;
                        line-height: 48px;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
                        display: flex;
                    }

                    &:hover {
                        background-color: var(--menu-history-selected-bg);
                    }

                    &:focus {
                        background-color: var(--menu-history-selected-bg);
                    }

                    &:nth-child(4) {
                        > span {
                            border-bottom: 0px solid rgba(255, 255, 255, 0.15);
                        }
                    }
                }

                .popper__arrow {
                    display: none;
                }
            }
        }
    }
}

.left-menu-hidden-bar {
    width: 64px;
    background: var(--menu-bar-bg);

    .hidden-bar__header {
        width: 100%;

        .header-logo-wrap {
            width: 100%;
            padding: 24px 20px;

            .header-logo {
                width: 26px;
                height: 30px;
                background-image: var(--system-logo);
                background-repeat: no-repeat;
                background-size: contain;
            }
        }

        .header-add-wrap {
            width: 40px;
            height: 40px;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid rgba($color: #ffffff, $alpha: 0.45);
            margin: 12px;

            .header-add {
                width: 16px;
                height: 16px;
            }
        }
    }

    .hidden-bar__footer {
        width: 100%;
        height: 56px;
        position: absolute;
        bottom: 0;
        box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15);
        padding: 20px 22px;
    }
}
</style>
